import * as React from 'react';

import swishHorizontal from 'components/icons/PaymentSwish/assets/atom-logo-swish-horizontal.png';

interface Props {
    width?: number;
    height?: number;
}

export const PaymentSwish: React.FunctionComponent<Props> = ({width, height}) => {

    return (
        <img alt='Swish' src={swishHorizontal} width={width} height={height} />
    );
};
